import { AssetSummary } from '@imcc/transport';
import { createAction, props } from '@ngrx/store';

export const loadSummarySuccess = createAction(
  '[Load Summary Success] Load Summary Success',
  props<{ summary: AssetSummary }>(),
);
